import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "zipFields", "radiusFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedType = this.radioTargets.find(r => r.checked)?.value || "zip_code"

    if (selectedType === "zip_code") {
      this.zipFieldsTarget.classList.remove("hidden")
      this.radiusFieldsTarget.classList.add("hidden")

      // Dispatch event to initialize/resize the zip map when shown
      setTimeout(() => {
        this.zipFieldsTarget.dispatchEvent(new CustomEvent('zone-type:zip-shown', { bubbles: true }))
      }, 100)
    } else {
      this.zipFieldsTarget.classList.add("hidden")
      this.radiusFieldsTarget.classList.remove("hidden")

      // Dispatch event to initialize/resize the radius map when shown
      setTimeout(() => {
        this.radiusFieldsTarget.dispatchEvent(new CustomEvent('zone-type:radius-shown', { bubbles: true }))
      }, 100)
    }
  }
}
